import { createRoutes } from '@/utils/core';
import BasicLayout from '@/layouts/BasicLayout';
import UserLayout from '@/layouts/UserLayout';
import MobileLayout from '@/layouts/MobileLayout';

/** 首页 */
import HomePage from './HomePage';

/** 导航栏 */
import UserCenter from './NavBar/UserCenter';
import StationNews from './NavBar/StationNews';
import AuditNotice from './NavBar/AuditNotice';
import SystemNotice from './NavBar/SystemNotice';

/** 快速发布 */
import QuickPublish from './QuickPublish';

/** 节目管理 */
import Template from './Program/Template';
import Playlist from './Program/Playlist';
import Schedule from './Program/Schedule';
import CloudSplice from './Program/CloudSplice';
import ScrollText from './Program/ScrollText';

/** 播放计划 */
import PlayPlan from './Program/PlayPlan';
import PlayPlanPublish from './Program/PlayPlanPublish';

/** 素材管理 */
import Material from './Material/Material';
import Price from './System/Price';

/** 客流量 */
import AdvRank from './Flow/AdvRank';
import FlowLine from './Flow/FlowLine';
import FlowPie from './Flow/FlowPie';

/** 系统设置 */
import Org from './System/Org';
import Role from './System/Role';
import User from './System/User';
import SysConfig from './System/SysConfig';
import UpgradeFile from './System/UpgradeFile';
import DataBase from './System/DataBase';
import CountryCode from './System/CountryCode';

/** 日志管理 */
import OperLog from './System/OperLog';
import ClientLog from './System/ClientLog';
import ClientErrorLog from './System/ClientErrorLog';
import ProgramLog from './System/ProgramLog';

/** 终端管理 */
import Client from './Client/Client';
import Recharge from './Client/Recharge';
import RechargeLog from './Client/RechargeLog';
import ClientOnline from './ClientOnlineStatistics';
import ClientUpgrade from './Client/ClientUpgrade';

/** 微信二维码 */
import Wechat from './System/Wechat';

/** 插件市场 */
import PluginMarket from './Plugin/PluginMarket';

/** 我的插件 */
import MyPlugin from './Plugin/MyPlugin';

/** 手机网页版 */
import Mobile from './Mobile/Content';
import MobileLogin from './Mobile/Login';

import NotFound from './Pages/404';
import ScreenLock from './Pages/ScreenLock';
import Page500 from './Pages/500';
import Coming from './Pages/Coming';
import Gallery from './Pages/Gallery';
import Result from './Pages/Result';
import Login from './Login';
import Register from './Register';
import Retrieve from './Retrieve';
import LoginByToken from './LoginByToken';
import Dashboard from './Dashboard';
import Blank from './Blank';
import Toolbar from './Widgets/Toolbar';
import BaseComponent from './Widgets/BaseComponent';
import Column from './Widgets/Column';
import TransferTree from './Widgets/TransferTree';
import SearchBar from './Widgets/SearchBar';
import DataTable from './Widgets/DataTable';
import Form from './Widgets/Form';
import EC from './Widgets/Charts/EC';
import G2 from './Widgets/Charts/G2';
import Icon from './UI/Icon';
import Mask from './UI/Mask';
import Editor from './UI/Editor';
import CSSAnimate from './UI/CSSAnimate';
import Alerts from './UI/Alerts';
import Button from './UI/Button';
import CRUD from './Business/CRUD';


const routesConfig = (app) => ([
  {
    path: '/sign',
    title: '登录',
    indexRoute: '/sign/login',
    component: UserLayout,
    childRoutes: [
      Login(app),
      LoginByToken(app),
      Register(app),
      Wechat(app),
      Retrieve(app),
      NotFound()  // 这个要放到最下面，当所有路由当没匹配到时会进入这个页面
    ]
  }, {
    path: '/link',
    title: '登录',
    indexRoute: '/link/mobile',
    component: MobileLayout,
    childRoutes: [
      MobileLogin(app),
      Mobile(app),
      NotFound()  // 这个要放到最下面，当所有路由当没匹配到时会进入这个页面
    ]
  }, {
    path: '/',
    title: '',
    component: BasicLayout,
    indexRoute: '/homePage',
    childRoutes: [
      Material(app),
      OperLog(app),
      ClientLog(app),
      ClientErrorLog(app),
      ProgramLog(app),
      Price(app),
      Template(app),
      Playlist(app),
      Schedule(app),
      CloudSplice(app),
      ScrollText(app),
      PlayPlan(app),
      PlayPlanPublish(app),
      Org(app),
      Role(app),
      User(app),
      SysConfig(app),
      Client(app),
      ClientUpgrade(app),
      Recharge(app),
      RechargeLog(app),
      HomePage(app),
      UserCenter(app),
      UpgradeFile(app),
      StationNews(app),
      AuditNotice(app),
      SystemNotice(app),
      ClientOnline(app),
      QuickPublish(app),
      AdvRank(app),
      FlowLine(app),
      FlowPie(app),
      DataBase(app),
      CountryCode(app),
      PluginMarket(app),
      MyPlugin(app),

      Dashboard(app),
      Blank(app),
      Toolbar(app),
      Column(),
      SearchBar(),
      EC(app),
      G2(app),
      Icon(),
      Mask(),
      Editor(),
      CSSAnimate(),
      Alerts(),
      Button(),
      DataTable(app),
      Form(app),
      TransferTree(app),
      BaseComponent(),
      CRUD(app),
      Coming(),
      ScreenLock(),
      Gallery(),
      Result(),
      Page500(),
      NotFound(), // 这个要放到最下面，当所有路由当没匹配到时会进入这个页面
    ]
  }
]);

export default app => createRoutes(app, routesConfig);


// WEBPACK FOOTER //
// ./src/routes/index.js